import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91796e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "grid-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "market"
}, "Market", -1))
const _hoisted_5 = {
  id: "market",
  class: "dropdown invalid-input input-field-margin",
  disabled: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "owner"
}, "Owner", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "grid-item-left" }, "Journal Reference", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["required"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "accountingDate"
}, "Accounting Date", -1))
const _hoisted_13 = { class: "date-picker input-field-margin" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "headerDescription"
}, "Header Description", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "line-item-separation-text",
  for: "market"
}, "LINE ITEMS", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_17 = { style: {"grid-column":"span 2"} }
const _hoisted_18 = ["for"]
const _hoisted_19 = ["onUpdate:modelValue", "id"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["for"]
const _hoisted_22 = ["onUpdate:modelValue", "id"]
const _hoisted_23 = ["for"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "grid-item-left" }, "Transaction Type", -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["for"]
const _hoisted_28 = ["onUpdate:modelValue", "id"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["for"]
const _hoisted_31 = ["onUpdate:modelValue", "id"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_33 = { style: {"grid-column":"span 2","display":"flex","justify-content":"center","gap":"10px"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-btn-centre" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "submit-btn",
    type: "submit"
  }, " Preview Submission ")
], -1))

import { computed, onBeforeMount, Ref, ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import CurrencyInput from "@/components/CurrencyInput.vue";
import { defaultMarket, MarketCurrency, marketSelection, ownerSelection } from "@/services/helpers/Helper";
import { manualJournalingEnums } from "@/services/network";
import {  MarketSelection } from '@/services/helpers/Helper';
import IManualJournal from "@/Interfaces/Journaling/ManualJournal/IManualJournal";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
import IManualJournalLineItems from "@/Interfaces/Journaling/ManualJournal/IManualJournalLineItems";
import IManualJournalingEnums from "@/Interfaces/Journaling/ManualJournal/IManualJournalingEnums";
import IManualJournalPreviewTable from "@/Interfaces/Journaling/ManualJournal/IPostManualJournalPreviewTable";
import ManualJournalPopUp from "@/components/ManualJournalPopUp.vue";
import router from "@/router";
import { RoutePaths } from "@/router/RouteDetails";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import { contractOwners as contractOwnersNetworkService } from "@/services/network";

enum JournalReferenceType {
    MANUAL = 'manual',
    AUTO_GENERATE = 'Auto Generate',
}
enum TransactionType {
    DEBIT = "debit",
    CREDIT = "credit"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ManualJournal',
  setup(__props) {


const contractOwners = ref<ContractOwner[]>([]);
const manualJNLPopUp= ref(false);
const journalReference = ref("")
const accountingDate = ref<Date>()
const headerDescription = ref("")
const previewTable = ref<IManualJournalPreviewTable[]>([]);
const journalReferenceTypeSelection = ref(JournalReferenceType.MANUAL);
const textInputOptions = { format: "yyyy/MM/dd" };
const working = ref(false);
const preFetchedEnums = ref<IManualJournalingEnums>();
const previewData = ref<IManualJournal>({
    Market: "",
    JournalReference: "",
    AccountingDate: "",
    HeaderDescription: "",
    LineItems: [],
    OwnerID: ""
});
const journalLineItems: Ref<IManualJournalLineItems[]> = ref([
    {
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.CREDIT,
        TaxCode: "",
        TaxReturn: false,
    },
    {
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.DEBIT,
        TaxCode: "",
        TaxReturn: false,
    }
]);
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
const FormatDateSelection = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0];
};
const taxCodeOptions = computed(() => {
    if (!preFetchedEnums.value?.TaxCodes){
        return [];
    } 
    return preFetchedEnums.value.TaxCodes.map(code => (
        {
            label: formatEnumValue(code),
            value: code
        }
    ));
});
const accountOptions = computed(() => {
    if (!preFetchedEnums.value?.Accounts){
        return [];
    } 
    return preFetchedEnums.value.Accounts.map(account => (
        {
            label: formatEnumValue(account),
            value: account
        }
    )).sort((a, b) => a.label.localeCompare(b.label));;
});
onBeforeMount(async() => {
    marketSelection.value = defaultMarket;
    await GetContractOwners()
    await GetAccountAndTaxCodeEnums()
})
async function GetContractOwners() {
    try {
        const res = await contractOwnersNetworkService.get()
        const data = res.data.filter( x => x.Market == marketSelection.value).sort((a, b) => {
                const aId = a?.OwnerId ?? "";
                const bId = b?.OwnerId ?? "";
                return bId.localeCompare(aId);
            });

        contractOwners.value = data;
        ownerSelection.value = contractOwners.value[0].OwnerId ?? "";
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: "Contract Owners",
            error,
        });
    }
}
function formatEnumValue (string: string){
    return string.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (word) => word.toUpperCase());
};
function AddLineItem(){
    journalLineItems.value.push({
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.DEBIT,
        TaxCode: "",
        TaxReturn: false,
    });
}
function RemoveLineItem(){
    journalLineItems.value.pop();
}
async function GetAccountAndTaxCodeEnums(){ 
    try{
        const response = await manualJournalingEnums.get()
        preFetchedEnums.value = response.data
    }catch(error){
        useNotifierWithErrFormatter().error({ error, errorType:"Failed to pre-fetch accout and tax code information"});
    }
}
async function CreateManualJournalEntryPreview() {
    previewData.value = {
        OwnerID: ownerSelection.value,
        Market: marketSelection.value,
        JournalReference: journalReferenceTypeSelection.value == JournalReferenceType.AUTO_GENERATE? "Auto Generated" : journalReference.value,
        AccountingDate: accountingDate.value? FormatDateSelection(accountingDate.value) :  "",
        HeaderDescription: headerDescription.value,
        LineItems: journalLineItems.value
    }
    previewTable.value = previewData.value.LineItems.map(
        lineItem => ({
            Account: lineItem.Account,
            Description: lineItem.Description,
            DebitAmount: lineItem.TransactionType === TransactionType.DEBIT ? lineItem.Amount : undefined,
            CreditAmount: lineItem.TransactionType === TransactionType.CREDIT ? lineItem.Amount : undefined,
            TaxCode: lineItem.TaxCode,
            TaxReturn: lineItem.TaxReturn
        })
    );

    manualJNLPopUp.value = true;
}
function journalingPageRedirect(){
    router.push({ path: RoutePaths.Journaling });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (CreateManualJournalEntryPreview()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("select", _hoisted_5, [
              _createElementVNode("option", null, _toDisplayString(_unref(MarketSelection).GB), 1)
            ]),
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(ownerSelection) ? (ownerSelection).value = $event : null)),
              class: "form-input input-field-margin",
              required: "",
              id: "owner"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOwners.value, (contractOwner) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: contractOwner.OwnerId,
                  key: contractOwner.OwnerId
                }, _toDisplayString(contractOwner.FullName), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(ownerSelection)]
            ]),
            _hoisted_8,
            _createVNode(GroupedInputButton, { class: "button-group input-field-margin" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: _normalizeClass(journalReferenceTypeSelection.value == JournalReferenceType.AUTO_GENERATE?  'btn-not-selected default-btn left-btn' : 'default-btn left-btn'),
                  title: "Select Journal Reference",
                  disabled: working.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (journalReferenceTypeSelection.value = JournalReferenceType.MANUAL)),
                  type: "button"
                }, " Manual ", 10, _hoisted_9),
                _createElementVNode("button", {
                  title: "Select Journal Reference",
                  class: _normalizeClass(journalReferenceTypeSelection.value == JournalReferenceType.MANUAL?  'btn-not-selected default-btn left-btn' : 'default-btn left-btn'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (journalReferenceTypeSelection.value = JournalReferenceType.AUTO_GENERATE)),
                  type: "button"
                }, " Auto Generate ", 2)
              ]),
              _: 1
            }),
            (journalReferenceTypeSelection.value == JournalReferenceType.MANUAL)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10))
              : _createCommentVNode("", true),
            (journalReferenceTypeSelection.value == JournalReferenceType.MANUAL)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((journalReference).value = $event)),
                  class: "form-input input-field-margin",
                  type: "text",
                  maxlength: "64",
                  placeholder: "Manual Journal Reference",
                  required: journalReferenceTypeSelection.value == JournalReferenceType.MANUAL? true: false
                }, null, 8, _hoisted_11)), [
                  [_vModelText, journalReference.value]
                ])
              : _createCommentVNode("", true),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(DatePicker), {
                type: "date",
                "enable-time-picker": false,
                format: FormatDatePicker,
                placeholder: "Select Accounting Date...",
                "text-input-options": textInputOptions,
                "text-input": "",
                teleport: true,
                id: "accountingDate",
                modelValue: accountingDate.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((accountingDate).value = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((headerDescription).value = $event)),
              class: "form-input input-field-margin",
              type: "text",
              maxlength: "200",
              placeholder: "",
              id: "headerDescription",
              required: ""
            }, null, 512), [
              [_vModelText, headerDescription.value]
            ]),
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(journalLineItems.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "grid-container"
                }, [
                  _createElementVNode("label", {
                    class: "grid-item-left",
                    for: 'account-' + index
                  }, "Account", 8, _hoisted_18),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((item.Account) = $event),
                    class: "form-input input-field-margin",
                    id: 'account-' + index,
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.label), 9, _hoisted_20))
                    }), 128))
                  ], 8, _hoisted_19), [
                    [_vModelSelect, item.Account]
                  ]),
                  _createElementVNode("label", {
                    class: "grid-item-left",
                    for: 'description-' + index
                  }, "Description", 8, _hoisted_21),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((item.Description) = $event),
                    class: "form-input input-field-margin",
                    type: "text",
                    maxlength: "255",
                    id: 'description-' + index,
                    placeholder: "Enter Description",
                    required: ""
                  }, null, 8, _hoisted_22), [
                    [_vModelText, item.Description]
                  ]),
                  _createElementVNode("label", {
                    class: "grid-item-left",
                    for: 'amount-' + index
                  }, "Amount", 8, _hoisted_23),
                  _createVNode(CurrencyInput, {
                    modelValue: item.Amount,
                    "onUpdate:modelValue": ($event: any) => ((item.Amount) = $event),
                    min: 0.01,
                    step: 0.01,
                    currency: _unref(MarketCurrency)[_unref(marketSelection)],
                    required: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "currency"]),
                  _hoisted_24,
                  _createVNode(GroupedInputButton, { class: "button-group input-field-margin" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: _normalizeClass(item.TransactionType === TransactionType.DEBIT ? 'default-btn left-btn' : 'btn-not-selected default-btn left-btn'),
                        title: "Select Transaction Type",
                        type: "button",
                        onClick: ($event: any) => (item.TransactionType = TransactionType.DEBIT)
                      }, " Debit ", 10, _hoisted_25),
                      _createElementVNode("button", {
                        class: _normalizeClass(item.TransactionType === TransactionType.CREDIT ? 'default-btn right-btn' : 'btn-not-selected default-btn right-btn'),
                        title: "Select Transaction Type",
                        type: "button",
                        onClick: ($event: any) => (item.TransactionType = TransactionType.CREDIT)
                      }, " Credit ", 10, _hoisted_26)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("label", {
                    class: "grid-item-left",
                    for: 'taxCode-' + index
                  }, "Tax Code", 8, _hoisted_27),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((item.TaxCode) = $event),
                    class: "form-input input-field-margin",
                    id: 'taxCode-' + index,
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxCodeOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.label), 9, _hoisted_29))
                    }), 128))
                  ], 8, _hoisted_28), [
                    [_vModelSelect, item.TaxCode]
                  ]),
                  _createElementVNode("label", {
                    class: "grid-item-left",
                    for: 'taxReturn-' + index
                  }, "Include on Tax Return", 8, _hoisted_30),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((item.TaxReturn) = $event),
                    type: "checkbox",
                    class: "input-field-margin",
                    id: 'taxReturn-' + index
                  }, null, 8, _hoisted_31), [
                    [_vModelCheckbox, item.TaxReturn]
                  ]),
                  _hoisted_32
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                onClick: AddLineItem,
                class: "submit-btn line-item-btn"
              }, " ➕ Add Line Item "),
              (journalLineItems.value.length > 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: RemoveLineItem,
                    class: "submit-btn line-item-btn"
                  }, " ➖ Remove Line Item "))
                : _createCommentVNode("", true)
            ]),
            _hoisted_34
          ])
        ], 32)
      ])
    ]),
    _createVNode(ManualJournalPopUp, {
      modelValue: manualJNLPopUp.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((manualJNLPopUp).value = $event)),
      previewData: previewData.value,
      previewTable: previewTable.value,
      onConfirm: journalingPageRedirect
    }, null, 8, ["modelValue", "previewData", "previewTable"])
  ], 64))
}
}

})